// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import MyOrders from './MyOrders';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(MyOrders);
